import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContentPreviewComponent } from './content-preview.component';
import { SafePipe } from './safe.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgDatepickerModule } from 'ng2-datepicker';
import { TagInputModule } from 'ngx-chips';
import { ContentRatingsModule } from './../ratings/content-ratings/content-ratings.module';
import { RankModule } from './../ratings/rank/rank.module';


TagInputModule.withDefaults({
  tagInput: {
    modelAsStrings: true,
    placeholder: '+ Tag'
  }
});

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgDatepickerModule,
    BrowserAnimationsModule,
    TagInputModule,
    ContentRatingsModule,
    RankModule
  ],
  exports: [
    ContentPreviewComponent
      ],
  declarations: [ContentPreviewComponent, SafePipe],
  providers: []
})
export class ContentPreviewModule { }
